<template>
  <div class="sponsors-wrapper">
    <h2 class="h2">Thanks to Our Sponsors</h2>
    <div
      class="panel"
      v-for="(section, index) in sections"
      :key="index"
      :class="`sponsors-${section.size}`"
    >
      <div class="panel__title">{{ section.title }}</div>
      <div class="panel__content sponsors">
        <div
          class="sponsor"
          v-for="(sponsor, index2) in section.sponsors"
          :key="index2"
        >
          <component
            :is="sponsor.url ? 'a' : 'div'"
            class="sponsor__link"
            :class="{ 'sponsor__link-largefont': sponsor.largefont }"
            target="_blank"
            :href="sponsor.url"
          >
            <img v-if="sponsor.logo" :src="sponsor.logo" :alt="sponsor.name" />
            <div v-else v-html="sponsor.name"></div>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    const getImage = name => require(`@/assets/sponsors/${name}.png`);

    return {
      sections: [
        {
          title: "Presenting Sponsor",
          size: "large",
          sponsors: [
            {
              name: "RS Hanline & Company, LLC",
              url: "https://www.rshanline.com",
              logo: getImage("hanline")
            }
          ]
        },
        {
          title: "Miracle Sponsor",
          size: "medium",
          sponsors: [
            {
              name: "Huntington Bank",
              url: "https://www.huntington.com",
              logo: getImage("huntington")
            }
          ]
        },
        {
          title: "Hope Sponsors",
          size: "small",
          sponsors: [
            {
              name: "Freshmark Sugardale",
              logo: getImage("sugardale"),
              url: "https://www.sugardale.com/"
            },
            {
              name: "Petland",
              logo: getImage("petland"),
              url: "https://www.petland-ohio.com/"
            },
            {
              name: "Sbarro",
              logo: getImage("sbarro"),
              url: "https://sbarro.com/"
            },
            {
              name: "Wesney Construction",
              logo: getImage("wesney"),
              url: "http://www.wesneyconstruction.com/"
            },
            {
              name: "Roetzel",
              logo: getImage("roetzel"),
              url: "https://www.ralaw.com/"
            },
            {
              name: "Meyers Wealth Management",
              logo: getImage("meyers"),
              url: "https://meyerswealthmgmt.com/"
            },
            {
              name: "VELA investment Management",
              logo: getImage("vela"),
              url: "https://vela-im.com/"
            },
            {
              name: "T Marzetti Company",
              logo: getImage("marzetti"),
              url: "https://marzetti.com/"
            }
          ]
        },
        {
          title: "In-Kind Sponsors",
          sponsors: [
            { name: "Preston Eatery" },
            { name: "Anthony-Thomas Chocolates" },
            { name: "Auction Ohio" }
          ]
        },
        {
          title: "St. Jude Ohio Market Sponsor",
          size: "medium",
          sponsors: [
            {
              name: "Greif, Inc.",
              url: "https://www.greif.com/",
              logo: getImage("greif")
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.sponsors {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 30px 30px 10px;
  &-large {
    .sponsor__link {
      height: 180px;
    }
  }
  &-medium {
    .sponsor__link {
      height: 110px;
      max-width: 370px;
    }
  }
  &-small {
    .sponsor {
      flex-basis: calc(25% - 40px);
      @media screen and (max-width: 960px) {
        flex-basis: calc(50% - 40px);
      }
      display: flex;
      justify-content: center;
      &__link {
        height: 70px;
      }
    }
  }
}

.sponsors-wrapper {
  margin: 0 120px 50px;

  .panel {
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    overflow: hidden;
    margin: 0 0 21px;

    &__title {
      color: $stjude-red;
      font-weight: 700;
      font-size: 20px;
      text-align: center;
      padding: 6px;
      border-bottom: 1px solid #dcdce1;
    }
  }
}

.sponsor {
  margin: 0 20px 20px;
  min-height: 70px;
  display: flex;

  &__link {
    line-height: 1.2;
    text-decoration: none;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 6px;
    white-space: pre-line;
    position: relative;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.sponsor__link {
  font-size: 18px;
  &.sponsor__link-largefont {
    font-size: 36px;
  }
}

@media screen and (max-width: 960px) {
  .sponsors-wrapper {
    margin: 20px;
  }

  .sponsors {
    padding-left: 20px;
    padding-right: 20px;
  }

  .sponsor__link {
    padding: 0;
    &.sponsor__link-largefont {
      font-size: 18px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
